import React from "react";
import "./ticker.scss";

const coins =
  "1,1027,1839,52,2010,6636,7083,2,1975,2416,1831,2280,512,1958,3077,74,5426,1765,328,3602,2011,7278,3794";

const coinmarketcapMarqueeId = "bl-cm-marquee";

const forceDomContentLoadedEvent = () => {
  window.document.dispatchEvent(
    new Event("DOMContentLoaded", {
      bubbles: true,
      cancelable: true
    })
  );
};

export default class Ticker extends React.Component {
  constructor() {
    super();
    this.state = {
      theme: document.documentElement.getAttribute("data-theme")
    };
  }

  componentDidMount() {
    this.handleCoinmarketcapMarqueeScript();
    this.observeThemeChanges();
  }

  componentWillUnmount() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  observeThemeChanges() {
    const targetNode = document.documentElement;
    const config = { attributes: true };
    const callback = (mutationsList, observer) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes") {
          if (
            targetNode.getAttribute(mutation.attributeName) !== this.state.theme
          ) {
            this.setState(
              {
                theme: targetNode.getAttribute(mutation.attributeName)
              },
              () => {
                forceDomContentLoadedEvent();
              }
            );
          }
        }
      }
    };

    this.observer = new MutationObserver(callback);

    this.observer.observe(targetNode, config);
  }

  handleCoinmarketcapMarqueeScript() {
    if (document.getElementById(coinmarketcapMarqueeId)) {
      forceDomContentLoadedEvent();
      return;
    }

    const coinmarketcapMarqueeScript = document.createElement("script");

    coinmarketcapMarqueeScript.setAttribute("id", "bl-cm-marquee");

    coinmarketcapMarqueeScript.setAttribute(
      "src",
      "https://files.coinmarketcap.com/static/widget/coinMarquee.js"
    );
    coinmarketcapMarqueeScript.setAttribute("type", "text/javascript");

    coinmarketcapMarqueeScript.onload = forceDomContentLoadedEvent;
    document.body.appendChild(coinmarketcapMarqueeScript);
  }

  render() {
    return (
      <div
        className="coinmarketcap-widget-wrapper"
        id="coinmarketcap-widget-marquee"
        coins={coins}
        currency="USD"
        key={this.state.theme}
        theme={this.state.theme}
        transparent="false"
        show-symbol-logo="true"
        style={{ maxWidth: "500px" }}
      ></div>
    );
  }
}
